import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { getDecodedToken } from "./jwtDecoder";
import Cookies from 'js-cookie';
export { setLocalCookies, getCookie, removeCookies };
var a_second = 1000;
function setLocalCookies(tokens, domain) {
  var decodedAccessToken = getDecodedToken(tokens.accessToken);
  var decodedIdToken = getDecodedToken(tokens.idToken);
  var options = {
    domain: domain,
    sameSite: 'none',
    secure: true,
    path: '/'
  };
  Cookies.set('access_token', tokens.accessToken, _objectSpread(_objectSpread({}, options), {}, {
    expires: new Date(decodedAccessToken.exp * a_second)
  }));
  Cookies.set('id_token', tokens.idToken, _objectSpread(_objectSpread({}, options), {}, {
    expires: new Date(decodedIdToken.exp * a_second)
  }));
}
function getCookie(cookieName) {
  return Cookies.get(cookieName);
}
function removeCookies(domain) {
  Cookies.remove('access_token', {
    domain: domain
  });
  Cookies.remove('id_token', {
    domain: domain
  });
}